import { BreadCrumb } from "primereact/breadcrumb";
import { routes } from "../../../routes";
import { useEffect, useRef, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import ActionBtn from "../../../components/dashboard/btn/ActionBtn";
import { SelectButton } from "primereact/selectbutton";
import { TextInput } from "../../../components/formLibs/FormLibs";
import DeleteConfirmation from "../../../components/modal/DeleteConfirmation";
import { FilterMatchMode } from "primereact/api";
import SearchComponent from "../../../components/datatable/SearchComponent";
import { Toast } from "primereact/toast";
import { RadioButton } from "primereact/radiobutton";
import TrainingService from "../../../api/TrainingService";
import RequirementService from "../../../api/RequirementService";

export default function Requirement() {
  const [classroom, setClassroom] = useState("");
  const [refresh, setRefresh] = useState(true);
  const [updateVisible, setUpdateVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const items = [
    {
      label: "Pré-requis",
      url: routes.dashboard.requirement.path,
    },
    // eslint-disable-next-line no-use-before-define
    { label: classroom ? classroom.name : "Liste" },
  ];

  const candidate = {
    icon: "pi pi-wallet",
    url: routes.dashboard.statistic.path,
  };
  const [selectedAnswer, setSelectedAnswer] = useState("");
  const [classrooms, setClassrooms] = useState([]);
  const [requirements, setRequirements] = useState([]);
  const [requirement, setRequirement] = useState();
  const [question, setQuestion] = useState("");
  const toogleOptions = ["Non", "Oui"];
  const [toogleValue, setToogleValue] = useState(toogleOptions[0]);
  const toast = useRef(null);
  const [confirm, setConfirm] = useState(false);
  const [addVisible, setAddVisible] = useState(false);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    //name: { value: null, matchMode: FilterMatchMode.STARTS_WITH }
  });

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  const header = () => {
    return (
      <div className="flex justify-content-between">
        <Button
          icon="pi pi-plus"
          label="Ajouter un pré-requis"
          onClick={() => setAddVisible(true)}
        />
        <SearchComponent
          globalFilterValue={globalFilterValue}
          onGlobalFilterChange={onGlobalFilterChange}
        />
      </div>
    );
  };

  const actionTemplate = (rowData) => {
    return (
      <div className="flex flex-wrap justify-content-start gap-3">
        <ActionBtn
          icon="pi pi-pencil"
          severity="info"
          tooltip="Modifier"
          handleClick={() => handleUpdateVisible(rowData.id)}
        />
        <ActionBtn
          icon="pi pi-trash"
          severity="danger"
          tooltip="Supprimer"
          handleClick={() => confirmDelete(rowData.id)}
        />
      </div>
    );
  };

  const updateStatus = (e, rowData) => {
    console.log("e.value", e.value);
    let data = rowData;
    data.status = e.value == "Oui" ? "yes" : "no";
    RequirementService.update(rowData.id, data).then((res) => {
      setRefresh(!refresh);
    });
  };
  const updateRequirement = (rowData) => {
    RequirementService.update(rowData.id, rowData).then((res) => {
      setRefresh(!refresh);
    });
  };
  const statutTemplate = (rowData) => {
    return (
      <div className="flex flex-wrap justify-content-start gap-3">
        <ul>
          {rowData && (
            <div className="card flex justify-content-center">
              <SelectButton
                value={rowData.status == 1 ? "Oui" : "Non"}
                onChange={(e) => updateStatus(e, rowData)}
                options={toogleOptions}
                pt={{
                  button: ({ context }) => ({
                    className: context.selected
                      ? "bg-green-400 border-cyan-400"
                      : undefined,
                  }),
                }}
              />
            </div>
          )}
        </ul>
      </div>
    );
  };
  const addRequirement = (e) => {
    e.preventDefault();
    if (!classroom || !question) {
      toast.current.show({
        severity: "error",
        summary: "Stop",
        detail: "Veuillez remplir tous les champs",
        life: 3000,
      });
    } else {
      const data = {
        requirement: question,
        training_program_id: classroom.id,
        status: selectedAnswer,
      };
      RequirementService.create(data)
        .then((res) => {
          //console.log("res", res)
          setRefresh(!refresh);
          setAddVisible(false);
        })
        .catch((err) => console.log("err", err));
    }
  };
  const deleteRequirement = () => {
    RequirementService.delete(requirement)
      .then((res) => {
        toast.current.show({
          severity: "info",
          summary: "Succèss",
          detail: "Pré-requis supprimé avec succès",
          life: 3000,
        });
        setRefresh(!refresh);
      })
      .catch((err) => {});
  };
  const rejectConfirmation = () => {
    toast.current.show({
      severity: "warn",
      summary: "Annulé",
      detail: "Vous aviez annulé la suppression",
      life: 3000,
    });
  };
  const confirmDelete = (id) => {
    setRequirement(id);
    setConfirm(true);
  };
  const handleUpdateVisible = (id) => {
    setRequirement(id);
    let cls = requirements?.filter((rol) => rol.id === parseInt(requirement))[0]
      ?.training_program;
    setClassroom(cls);
    setQuestion(
      requirements?.filter((rol) => rol.id === parseInt(id))[0]?.requirement
    );
    let answer =
      requirements?.filter((rol) => rol.id === parseInt(requirement))[0]
        ?.status == 1
        ? "yes"
        : "no";

    setSelectedAnswer(answer);
    setUpdateVisible(true);
  };

  useEffect(() => {
    TrainingService.getAll().then((res) => {
      setClassrooms(res.data.trainingPrograms);
    });
    RequirementService.getAll().then((res) => {
      setRequirements(res.data.requirements);
    });
  }, [refresh]);

  return (
    <div>
      <Toast ref={toast} />
      <DeleteConfirmation
        visible={confirm}
        onHide={() => setConfirm(false)}
        message={`Voulez-vous réellement supprimé le pré-requis ${
          requirements?.filter((rol) => rol.id === parseInt(requirement))[0]
            ?.requirement
        } ?`}
        accept={deleteRequirement}
        reject={rejectConfirmation}
      />
      <Dialog
        header="Ajouter un pré-requis"
        visible={addVisible}
        style={{ width: "50vw" }}
        onHide={() => setAddVisible(false)}
      >
        <form className="form" onSubmit={addRequirement}>
          <div className="form__item">
            <label htmlFor="site">Parcours</label>
            <div className="form__item__ic_p">
              <Dropdown
                value={classroom}
                onChange={(e) => {
                  setClassroom(e.value);
                }}
                options={classrooms}
                optionLabel="name"
                placeholder="Sectionner un parcours"
                className="w-full"
              />
            </div>
          </div>
          <div className="form__item">
            <label htmlFor="name">Pré-requis</label>
            <div className="form__item__ic_p">
              <TextInput
                type="text"
                name="name"
                label="name"
                handleChange={(e) => setQuestion(e.target.value)}
                // register={register}
              />
            </div>
          </div>
          <div className="flex align-items-center my-3">
            <label htmlFor="name">Réponse acceptable :</label>
            <div>
              <div className="flex align-items-center justify-content-evenly mx-4">
                <div className="flex align-items-center mr-3">
                  <RadioButton
                    inputId={"yes"}
                    name="category"
                    value={"yes"}
                    // {...register}
                    //inputRef={register.ref}
                    onChange={(e) => setSelectedAnswer(e.value)}
                    checked={selectedAnswer === "yes"}
                  />
                  <label htmlFor={"yes"} className="ml-2 mr-2">
                    Oui
                  </label>
                </div>
                <RadioButton
                  inputId={"no"}
                  name="category"
                  value={"no"}
                  /* {...register}
                  inputRef={register.ref} */
                  onChange={(e) => setSelectedAnswer(e.value)}
                  checked={selectedAnswer === "no"}
                />
                <label htmlFor={"no"} className="ml-2">
                  Non
                </label>
              </div>
            </div>
          </div>
          <div className="form__item">
            <button type="submit">
              Enregistrer{" "}
              <ProgressSpinner
                style={
                  loading
                    ? { width: "20px", height: "20px" }
                    : { width: "0px", height: "0px" }
                }
                strokeWidth="8"
                loading={loading}
              />
            </button>
          </div>
        </form>
      </Dialog>
      <Dialog
        header="Modifier pré-requis"
        visible={updateVisible}
        style={{ width: "50vw" }}
        onHide={() => setUpdateVisible(false)}
      >
        <form className="form" onSubmit={updateRequirement}>
          <div className="form__item">
            <label htmlFor="site">Parcours</label>
            <div className="form__item__ic_p">
              <Dropdown
                value={classroom}
                onChange={(e) => {
                  setClassroom(e.value);
                }}
                defaultValue={
                  requirements?.filter(
                    (rol) => rol.id === parseInt(requirement)
                  )[0]?.training_program
                }
                options={classrooms}
                optionLabel="name"
                placeholder="Sectionner un parcours"
                className="w-full"
              />
            </div>
          </div>
          <div className="form__item">
            <label htmlFor="name">Pré-requis</label>
            <div className="form__item__ic_p">
              <TextInput
                type="text"
                name="name"
                label="name"
                defaultValue={question}
                handleChange={(e) => setQuestion(e.target.value)}
                // register={register}
              />
            </div>
          </div>
          <div className="flex align-items-center my-3">
            <label htmlFor="name">Réponse acceptable :</label>
            <div>
              <div className="flex align-items-center justify-content-evenly mx-4">
                <div className="flex align-items-center mr-3">
                  <RadioButton
                    inputId={"yes"}
                    name="category"
                    value={"yes"}
                    // {...register}
                    //inputRef={register.ref}
                    onChange={(e) => setSelectedAnswer(e.value)}
                    checked={selectedAnswer === "yes"}
                    defaultValue={
                      requirements?.filter(
                        (rol) => rol.id === parseInt(requirement)
                      )[0]?.status == 1
                        ? "yes"
                        : "no"
                    }
                  />
                  <label htmlFor={"yes"} className="ml-2 mr-2">
                    Oui
                  </label>
                </div>
                <RadioButton
                  inputId={"no"}
                  name="category"
                  value={"no"}
                  /* {...register}
                  inputRef={register.ref} */
                  onChange={(e) => setSelectedAnswer(e.value)}
                  defaultValue={
                    requirements?.filter(
                      (rol) => rol.id === parseInt(requirement)
                    )[0]?.status == 1
                      ? "yes"
                      : "no"
                  }
                  checked={selectedAnswer === "no"}
                />
                <label htmlFor={"no"} className="ml-2">
                  Non
                </label>
              </div>
            </div>
          </div>
          <div className="form__item">
            <button type="submit">
              Enregistrer{" "}
              <ProgressSpinner
                style={
                  loading
                    ? { width: "20px", height: "20px" }
                    : { width: "0px", height: "0px" }
                }
                strokeWidth="8"
                loading={loading}
              />
            </button>
          </div>
        </form>
      </Dialog>
      <div>
        <BreadCrumb model={items} home={candidate} />
      </div>
      <div>
        <div>
          <DataTable
            header={header}
            value={requirements}
            tableStyle={{ minWidth: "50rem" }}
          >
            <Column
              field="training_program.name"
              header="Parcours"
              //body={actionTemplate}
            ></Column>
            <Column field="requirement" header="Question"></Column>
            <Column body={statutTemplate} header="Réponse acceptée"></Column>
            <Column header="Actions" body={actionTemplate}></Column>
          </DataTable>
        </div>
      </div>
    </div>
  );
}
